<div *ngIf="loader; else elseBlock" class="spinner">
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<ng-template #elseBlock>
  <div class="divHome">
    <h1>Reporte Entradas</h1>

    <div class="divButtons">
      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>FILES</mat-label>
        <mat-select
          [(value)]="selectNumberFile"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">Todos los Files</mat-option>
          <mat-option
            *ngFor="let numberFile of arrayFiles"
            [value]="numberFile"
            >{{ numberFile }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>CATEGORIA SERVICIO</mat-label>
        <mat-select
          [(value)]="categoriaOfServiceSelected"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let categoria of categoriasFiltradas"
            [value]="categoria"
          >
            {{ categoria }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>SERVICIO </mat-label>
        <mat-select
          [(value)]="selectService"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let service of arrayServices"
            value="{{ service }}"
            >{{ service }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>ESTADO OS</mat-label>
        <mat-select
          [(value)]="selectEstadoOS"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option
            *ngFor="let optionSelect of arraySelectEstadoOS"
            value="{{ optionSelect }}"
            >{{ optionSelect }}</mat-option
          >
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" class="buttonFilter">
        <mat-label>NUM OS </mat-label>
        <mat-select
          [(value)]="selectNumOS"
          (selectionChange)="applyFilterSelect()"
        >
          <mat-option value="{{ null }}">No seleccionar</mat-option>
          <mat-option *ngFor="let numOS of arrayNumOS" value="{{ numOS }}">{{
            numOS
          }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div style="display: flex; justify-content: center; padding-top: 1rem">
      <mat-form-field appearance="outline" class="divInputSearch">
        <input
          matInput
          [(ngModel)]="filterValue"
          (ngModelChange)="applyFilter()"
          placeholder="Buscar"
        />
      </mat-form-field>
    </div>

    <div class="secctionButtonOS" *ngIf="fileDataSource.data.length > 0">
      <div>
        <button
          mat-raised-button
          [ngClass]="{
            buttonActive: estadoBtnMasivo > 0,
            buttonDisable: estadoBtnMasivo === 0
          }"
          (click)="sendReservaOS()"
        >
          Generar OS
        </button>
      </div>
      <div style="height: 50%; height: 40px !important">
        <p
          *ngIf="estadoBtnMasivo === 0 && messageButtonOS"
          style="color: red; font-size: 0.6rem"
        >
          <i>* Seleccione los servicos que desea reservar Orden de Servico</i>
        </p>
      </div>
    </div>

    <div class="example-container mat-elevation-z8" *ngIf="fileDataSource">
      <mat-table [dataSource]="fileDataSource" matSort>
        <ng-container matColumnDef="Check">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="$event ? toggleAllRows() : null"
              [checked]="isAllSelected()"
            >
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox [checked]="row.checked" (change)="updateCheck(row)">
            </mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="fileNumber">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Número File
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.fileNumber }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numOS">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Número OS</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.order?.displayCode || row.order?.orderNumber }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numNP">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Número OP</mat-header-cell
          >
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.numNP }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="numReserva">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Número Reserva
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            <div class="icon-edit">
              {{ row.order?.reservationNumber ? row.order?.reservationNumber : "-" }}

              <span *ngIf="isOrderEditable(row)">
                <mat-icon
                  class="icon-edit-display"
                  (click)="
                    openDialogReservaManual(
                      row.tipoServicio,
                      row.nombreServicio,
                      row.idItinerary,
                      row.id,
                      row.objProvider.nombre,
                      true,
                      row
                    )
                  "
                  >edit</mat-icon
                >
              </span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nombreProveedor">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Nombre Proveedor
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row?.nombreProveedor }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="tipoMoneda">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Tipo Moneda
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.tipoMoneda }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoOS">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle dobleHeader"
          >
            Estado OS
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle dobleHeader">
            <div class="icon-edit">
              <span
                *ngIf="row.order?.orderStatus; else noEntradaOrderStatus"
                class="os-status"
                [attr.data-os-status]="row.order.orderStatus.toUpperCase()"
              >
                {{ row.order.orderStatus }}
              </span>
              <ng-template #noEntradaOrderStatus>-</ng-template>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="estadoReserva">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle dobleHeader"
          >
            Estado Reserva
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle dobleHeader">
            <div class="icon-edit">
              {{ row.order?.reservationStatus || '-' }}
              <mat-icon
                *ngIf="isOrderEditable(row)"
                class="icon-edit-display"
                (click)="
                  openDialogReservaManual(
                    row.tipoServicio,
                    row.nombreServicio,
                    row.idItinerary,
                    row.id,
                    row.objProvider.nombre,
                    false,
                    row
                  )
                "
                >date_range</mat-icon
              >
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="paxQuantity">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Pax
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.lstPaX?.length }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="day">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Día
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.day }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="nombreServicio">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle dobleHeader"
          >
            ACTIVIDAD
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle dobleHeader">
            <div class="icon-edit">
              <ng-container *ngIf="row.serviceAdicional; else nombreServicio">
                <div class="containerService">
                  <div>- {{ row.serviceAdicional[0].nameService }}</div>
                  <div>- {{ row.serviceAdicional[1].nameService }}</div>
                </div>
              </ng-container>
              <ng-template #nombreServicio>
                {{ row.nombreServicio }}
              </ng-template>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="categoriaServicio">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Categoría Servicio
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.categoriaServicio }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="correoReserva">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            Correo Reserva
          </mat-header-cell>
          <mat-cell *matCellDef="let row" class="bodyStyle">
            {{ row.objProvider?.correoReserva }}
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="verPDF">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="headerStyle"
          >
            VER PDF
          </mat-header-cell>
          <mat-cell
            *matCellDef="let row"
            class="bodyStyle"
            style="justify-content: flex-start !important"
          >
            <button
              mat-icon-button
              color="primary"
              *ngIf="canShowOrderPdf(row) || row.numNP"
              (click)="openDialogPdfOS(row.order?.orderNumber ? row.order.orderNumber : row.numNP)"
            >
              <mat-icon class="icon-color">picture_as_pdf</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="archivos">
          <mat-header-cell *matHeaderCellDef class="headerStyle oneHeader">
            Archivos
          </mat-header-cell>
          <mat-cell
            *matCellDef="let element; let i = index"
            class="bodyStyle oneHeader"
          >
            <button mat-icon-button (click)="openDialog(element)">
              <mat-icon class="icon-color">upload</mat-icon>
            </button>
          </mat-cell>
        </ng-container>

        <mat-header-row
          *matHeaderRowDef="fileDisplayedColumns"
        ></mat-header-row>
        <mat-row *matRowDef="let row; columns: fileDisplayedColumns"> </mat-row>
      </mat-table>
    </div>
    <mat-paginator
      [pageSize]="5"
      [pageSizeOptions]="[5, 10, 25, 100]"
    ></mat-paginator>
  </div>
</ng-template>
